// extracted by mini-css-extract-plugin
module.exports = {"messageHolder":"SelectChemicals_messageHolder__2Pq68"};